import { transparentize } from 'polished';
import styled from 'styled-components';

export const PendingPageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const PendingPageContent = styled.div`
  width: 100%;
  padding: 1rem;
  max-width: 50rem;
`;

export const NoPendingMessage = styled.div`
  padding: 1.75rem 0 3.5rem;
  width: fill-available;
  margin: 0.25rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.25;
`;

export const DateContainer = styled.div`
  margin-bottom: 2rem;
`;

export const DateTitle = styled.div`
  width: 100%;
  font-size: 1.25rem;
  border-bottom: 1px solid
    ${({ theme }) => transparentize(0.9, theme.foreground)};
  padding: 0.5rem 0;
  margin-bottom: 1rem;
`;

export const JobLine = styled.div`
  display: grid;
  grid-template-columns: 2rem 1fr 1fr 1fr;
  padding: 0.5rem;
  grid-column-gap: 0.5rem;
  align-items: center;
  cursor: pointer;
  transition: background-color 300ms;

  &:hover {
    background-color: ${({ theme }) => transparentize(0.9, theme.foreground)};
  }
`;
